import { useAICustomerDetailsAPI } from "@/app/hooks/api_hooks/customer_profile/useAICustomerDetailsAPI";
import { SparklesIcon } from "@heroicons/react/24/solid";
import { useEffect } from "react";

const AICustomerProfileCard: React.FC<{ customerId?: string }> = ({ customerId }) => {
  const { execute: fetchAICustomerDetails, aiCustomerDetails } = useAICustomerDetailsAPI();

  useEffect(() => {
    if (!customerId) return;
    fetchAICustomerDetails(customerId);
  }, [customerId, fetchAICustomerDetails]);

  const tableHeader = ["Name", "Address", "Pincode"];
  const customerLocation = aiCustomerDetails?.customer_details?.location;
  const tableRowValue = [
    aiCustomerDetails?.customer_details?.name ?? "--",
    customerLocation?.address_1 ?? "--",
    customerLocation?.pincode ?? "--",
  ];

  return (
    <div className="mt-2 px-2">
      <div className="my-4 flex items-center gap-2">
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
          <SparklesIcon className="h-4 w-4 text-purple-600" />
        </span>
        <p className="text-left text-sm font-sans font-bold text-gray-800">
          <span>AI Customer Profile</span>
        </p>
      </div>
      {aiCustomerDetails ? (
        <div className="mt-2 flow-root">
          <div className="bg-white rounded-lg">
            <table className="w-full border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
              <thead className="bg-[#F5F5F5] text-[#1F1F23] top-0 font-normal">
                <tr>
                  {tableHeader.map((key, index) => (
                    <th
                      key={`${key}:${index}`}
                      className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23] capitalize"
                    >
                      {key}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="overflow-hidden rounded-xl w-full">
                <tr className="group bg-white transition">
                  {tableRowValue.map((value, index) => (
                    <td key={`value:${index}`} className="px-3 py-3 whitespace-nowrap text-xs font-normal text-[#1F1F23]">
                      {value}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <p className="mt-2 text-xs text-[#808DA0]">No AI  customer profile details available.</p>
      )}
    </div>
  );
};

export default AICustomerProfileCard;
